import React from 'react';
import './title.css';

const title = (props) => {
  return (
    <div onClick={props.onClick} className="AS-title font-color-dark">
      <p className="font-color-dark">Step {props.index}</p>
      <h2>{props.title}</h2>
      <i className="material-icons">chevron_right</i>
    </div>
  )
}

export default title;



// WEBPACK FOOTER //
// ./src/views/PickerView/components/sidebar/Title.js